export const V1MTLINKMAPPER :any= {
    "AL1091": {
        "tiny_url": "https://tinyurl.com/yyahe695",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/91",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1091",
        "v1_app_link_code": "AL1091",
        "mt_id": 91
    },
    "AL1090": {
        "tiny_url": "https://tinyurl.com/y6q7nfmr",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/90",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1090",
        "v1_app_link_code": "AL1090",
        "mt_id": 90
    },
    "AL1089": {
        "tiny_url": "https://tinyurl.com/y5e2hmhh",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/89",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1089",
        "v1_app_link_code": "AL1089",
        "mt_id": 89
    },
    "AL1088": {
        "tiny_url": "https://tinyurl.com/y2njnl6x",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/88",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1088",
        "v1_app_link_code": "AL1088",
        "mt_id": 88
    },
    "AL1087": {
        "tiny_url": "https://tinyurl.com/y4rt9vbf",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/87",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1087",
        "v1_app_link_code": "AL1087",
        "mt_id": 87
    },
    "AL1086": {
        "tiny_url": "https://tinyurl.com/y5gxezsd",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/86",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1086",
        "v1_app_link_code": "AL1086",
        "mt_id": 86
    },
    "AL1085": {
        "tiny_url": "https://tinyurl.com/y55eq6cq",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/85",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1085",
        "v1_app_link_code": "AL1085",
        "mt_id": 85
    },
    "AL1084": {
        "tiny_url": "https://tinyurl.com/yxa8mg24",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/84",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1084",
        "v1_app_link_code": "AL1084",
        "mt_id": 84
    },
    "AL1083": {
        "tiny_url": "https://tinyurl.com/y3hzj7uw",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/83",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1083",
        "v1_app_link_code": "AL1083",
        "mt_id": 83
    },
    "AL1082": {
        "tiny_url": "https://tinyurl.com/y4nh6ayy",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/82",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1082",
        "v1_app_link_code": "AL1082",
        "mt_id": 82
    },
    "AL1081": {
        "tiny_url": "https://tinyurl.com/yywywc3d",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/81",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1081",
        "v1_app_link_code": "AL1081",
        "mt_id": 81
    },
    "AL1080": {
        "tiny_url": "https://tinyurl.com/y4c72wfm",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/80",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1080",
        "v1_app_link_code": "AL1080",
        "mt_id": 80
    },
    "AL1079": {
        "tiny_url": "https://tinyurl.com/yyntvtve",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/79",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1079",
        "v1_app_link_code": "AL1079",
        "mt_id": 79
    },
    "AL1078": {
        "tiny_url": "https://tinyurl.com/y2o2e4xw",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/78",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1078",
        "v1_app_link_code": "AL1078",
        "mt_id": 78
    },
    "AL1077": {
        "tiny_url": "https://tinyurl.com/y5m329en",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/77",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1077",
        "v1_app_link_code": "AL1077",
        "mt_id": 77
    },
    "AL1076": {
        "tiny_url": "https://tinyurl.com/y5e3j69m",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/76",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1076",
        "v1_app_link_code": "AL1076",
        "mt_id": 76
    },
    "AL1075": {
        "tiny_url": "https://tinyurl.com/yy8wotd3",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/75",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1075",
        "v1_app_link_code": "AL1075",
        "mt_id": 75
    },
    "AL1074": {
        "tiny_url": "https://tinyurl.com/y52tbzyc",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/74",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1074",
        "v1_app_link_code": "AL1074",
        "mt_id": 74
    },
    "AL1073": {
        "tiny_url": "https://tinyurl.com/y36yjqym",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/73",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1073",
        "v1_app_link_code": "AL1073",
        "mt_id": 73
    },
    "AL1072": {
        "tiny_url": "https://tinyurl.com/y3bv3wjb",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/72",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1072",
        "v1_app_link_code": "AL1072",
        "mt_id": 72
    },
    "AL1071": {
        "tiny_url": "https://tinyurl.com/y382qatw",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/71",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1071",
        "v1_app_link_code": "AL1071",
        "mt_id": 71
    },
    "AL1070": {
        "tiny_url": "https://tinyurl.com/y6jtzvlz",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/70",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1070",
        "v1_app_link_code": "AL1070",
        "mt_id": 70
    },
    "AL1069": {
        "tiny_url": "https://tinyurl.com/y3v7gw8d",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/69",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1069",
        "v1_app_link_code": "AL1069",
        "mt_id": 69
    },
    "AL1068": {
        "tiny_url": "https://tinyurl.com/ydz9tw8y",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/68",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1068",
        "v1_app_link_code": "AL1068",
        "mt_id": 68
    },
    "AL1067": {
        "tiny_url": "https://tinyurl.com/ycd3fb4k",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/67",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1067",
        "v1_app_link_code": "AL1067",
        "mt_id": 67
    },
    "AL1066": {
        "tiny_url": "https://tinyurl.com/y9sa8etc",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/66",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1066",
        "v1_app_link_code": "AL1066",
        "mt_id": 66
    },
    "AL1065": {
        "tiny_url": "https://tinyurl.com/y986wdvb",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/65",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1065",
        "v1_app_link_code": "AL1065",
        "mt_id": 65
    },
    "AL1064": {
        "tiny_url": "https://tinyurl.com/y9wd6xjv",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/64",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1064",
        "v1_app_link_code": "AL1064",
        "mt_id": 64
    },
    "AL1063": {
        "tiny_url": "https://tinyurl.com/yc4krg2t",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/63",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1063",
        "v1_app_link_code": "AL1063",
        "mt_id": 63
    },
    "AL1062": {
        "tiny_url": "https://tinyurl.com/y8z9g4pu",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/62",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1062",
        "v1_app_link_code": "AL1062",
        "mt_id": 62
    },
    "AL1061": {
        "tiny_url": "https://tinyurl.com/ydygjgjq",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/61",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1061",
        "v1_app_link_code": "AL1061",
        "mt_id": 61
    },
    "AL1060": {
        "tiny_url": "https://tinyurl.com/ydbcc9lx",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/60",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1060",
        "v1_app_link_code": "AL1060",
        "mt_id": 60
    },
    "AL1059": {
        "tiny_url": "https://tinyurl.com/ya3w53vq",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/59",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1059",
        "v1_app_link_code": "AL1059",
        "mt_id": 59
    },
    "AL1058": {
        "tiny_url": "https://tinyurl.com/yaorws3z",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/58",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1058",
        "v1_app_link_code": "AL1058",
        "mt_id": 58
    },
    "AL1057": {
        "tiny_url": "https://tinyurl.com/ycm82awo",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/57",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1057",
        "v1_app_link_code": "AL1057",
        "mt_id": 57
    },
    "AL1056": {
        "tiny_url": "https://tinyurl.com/yd7ekxk4",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/56",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1056",
        "v1_app_link_code": "AL1056",
        "mt_id": 56
    },
    "AL1055": {
        "tiny_url": "https://tinyurl.com/y72va2py",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/55",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1055",
        "v1_app_link_code": "AL1055",
        "mt_id": 55
    },
    "AL1054": {
        "tiny_url": "https://tinyurl.com/ybuuuqb4",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/54",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1054",
        "v1_app_link_code": "AL1054",
        "mt_id": 54
    },
    "AL1053": {
        "tiny_url": "https://tinyurl.com/y7hp5xow",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/53",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1053",
        "v1_app_link_code": "AL1053",
        "mt_id": 53
    },
    "AL1052": {
        "tiny_url": "https://tinyurl.com/ydflfhef",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/52",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1052",
        "v1_app_link_code": "AL1052",
        "mt_id": 52
    },
    "AL1051": {
        "tiny_url": "https://tinyurl.com/y8lc4f3n",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/51",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1051",
        "v1_app_link_code": "AL1051",
        "mt_id": 51
    },
    "AL1050": {
        "tiny_url": "https://tinyurl.com/ybue28g5",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/50",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1050",
        "v1_app_link_code": "AL1050",
        "mt_id": 50
    },
    "AL1049": {
        "tiny_url": "https://tinyurl.com/y9p2r5c6",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/49",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1049",
        "v1_app_link_code": "AL1049",
        "mt_id": 49
    },
    "AL1048": {
        "tiny_url": "https://tinyurl.com/y7gplfp9",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/48",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1048",
        "v1_app_link_code": "AL1048",
        "mt_id": 48
    },
    "AL1047": {
        "tiny_url": "https://tinyurl.com/ybgp2qgm",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/47",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1047",
        "v1_app_link_code": "AL1047",
        "mt_id": 47
    },
    "AL1046": {
        "tiny_url": "https://tinyurl.com/y9zjjkbm",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/46",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1046",
        "v1_app_link_code": "AL1046",
        "mt_id": 46
    },
    "AL1045": {
        "tiny_url": "https://tinyurl.com/ydauqwrc",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/45",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1045",
        "v1_app_link_code": "AL1045",
        "mt_id": 45
    },
    "AL1044": {
        "tiny_url": "https://tinyurl.com/ydxq3okx",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/44",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1044",
        "v1_app_link_code": "AL1044",
        "mt_id": 44
    },
    "AL1043": {
        "tiny_url": "https://tinyurl.com/y9elcmeq",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/43",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1043",
        "v1_app_link_code": "AL1043",
        "mt_id": 43
    },
    "AL1042": {
        "tiny_url": "https://tinyurl.com/ycfoweun",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/42",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1042",
        "v1_app_link_code": "AL1042",
        "mt_id": 42
    },
    "AL1041": {
        "tiny_url": "https://tinyurl.com/y9xdo9rk",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/41",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1041",
        "v1_app_link_code": "AL1041",
        "mt_id": 41
    },
    "AL1040": {
        "tiny_url": "https://tinyurl.com/y26r2bou",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/40",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1040",
        "v1_app_link_code": "AL1040",
        "mt_id": 40
    },
    "AL1039": {
        "tiny_url": "https://tinyurl.com/y5mlfxut",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/39",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1039",
        "v1_app_link_code": "AL1039",
        "mt_id": 39
    },
    "AL1038": {
        "tiny_url": "https://tinyurl.com/y2syqy4s",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/38",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1038",
        "v1_app_link_code": "AL1038",
        "mt_id": 38
    },
    "AL1037": {
        "tiny_url": "https://tinyurl.com/y5pm2axq",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/37",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1037",
        "v1_app_link_code": "AL1037",
        "mt_id": 37
    },
    "AL1036": {
        "tiny_url": "https://tinyurl.com/yg3egpxx",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/36",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1036",
        "v1_app_link_code": "AL1036",
        "mt_id": 36
    },
    "AL1035": {
        "tiny_url": "https://tinyurl.com/yew7sx4l",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/35",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1035",
        "v1_app_link_code": "AL1035",
        "mt_id": 35
    },
    "AL1034": {
        "tiny_url": "https://tinyurl.com/yg32s2vo",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/34",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1034",
        "v1_app_link_code": "AL1034",
        "mt_id": 34
    },
    "AL1033": {
        "tiny_url": "https://tinyurl.com/yfnu59bl",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/33",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1033",
        "v1_app_link_code": "AL1033",
        "mt_id": 33
    },
    "AL1032": {
        "tiny_url": "https://tinyurl.com/ye8dap48",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/32",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1032",
        "v1_app_link_code": "AL1032",
        "mt_id": 32
    },
    "AL1031": {
        "tiny_url": "https://tinyurl.com/yfn4phwu",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/31",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1031",
        "v1_app_link_code": "AL1031",
        "mt_id": 31
    },
    "AL1030": {
        "tiny_url": "https://tinyurl.com/ydjkdgr6",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/30",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1030",
        "v1_app_link_code": "AL1030",
        "mt_id": 30
    },
    "AL1029": {
        "tiny_url": "https://tinyurl.com/yjqjjpw6",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/29",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1029",
        "v1_app_link_code": "AL1029",
        "mt_id": 29
    },
    "AL1028": {
        "tiny_url": "https://tinyurl.com/ygzc4zzs",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/28",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1028",
        "v1_app_link_code": "AL1028",
        "mt_id": 28
    },
    "AL1027": {
        "tiny_url": "https://tinyurl.com/yf2sy4ez",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/27",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1027",
        "v1_app_link_code": "AL1027",
        "mt_id": 27
    },
    "AL1026": {
        "tiny_url": "https://tinyurl.com/yfov6yod",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/26",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1026",
        "v1_app_link_code": "AL1026",
        "mt_id": 26
    },
    "AL1025": {
        "tiny_url": "https://tinyurl.com/yzqsbwq5",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/25",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1025",
        "v1_app_link_code": "AL1025",
        "mt_id": 25
    },
    "AL1024": {
        "tiny_url": "https://tinyurl.com/yzjsogav",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/24",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1024",
        "v1_app_link_code": "AL1024",
        "mt_id": 24
    },
    "AL1023": {
        "tiny_url": "https://tinyurl.com/ygbxwzjz",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/23",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1023",
        "v1_app_link_code": "AL1023",
        "mt_id": 23
    },
    "AL1022": {
        "tiny_url": "https://tinyurl.com/yfsjevjk",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/22",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1022",
        "v1_app_link_code": "AL1022",
        "mt_id": 22
    },
    "AL1021": {
        "tiny_url": "https://tinyurl.com/yjvvabn5",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/21",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1021",
        "v1_app_link_code": "AL1021",
        "mt_id": 21
    },
    "AL1020": {
        "tiny_url": "https://tinyurl.com/yg6xf5wo",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/20",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1020",
        "v1_app_link_code": "AL1020",
        "mt_id": 20
    },
    "AL1019": {
        "tiny_url": "https://tinyurl.com/ygd3yh88",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/19",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1019",
        "v1_app_link_code": "AL1019",
        "mt_id": 19
    },
    "AL1018": {
        "tiny_url": "https://tinyurl.com/ygmms6co",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/18",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1018",
        "v1_app_link_code": "AL1018",
        "mt_id": 18
    },
    "AL1017": {
        "tiny_url": "https://tinyurl.com/yzf26d93",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/17",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1017",
        "v1_app_link_code": "AL1017",
        "mt_id": 17
    },
    "AL1016": {
        "tiny_url": "https://tinyurl.com/yz6paf9f",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/16",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1016",
        "v1_app_link_code": "AL1016",
        "mt_id": 16
    },
    "AL1015": {
        "tiny_url": "https://tinyurl.com/yjcunrh2",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/15",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1015",
        "v1_app_link_code": "AL1015",
        "mt_id": 15
    },
    "AL1014": {
        "tiny_url": "https://tinyurl.com/yjjzmgv5",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/14",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1014",
        "v1_app_link_code": "AL1014",
        "mt_id": 14
    },
    "AL1013": {
        "tiny_url": "https://tinyurl.com/yzomr3bp",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/13",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1013",
        "v1_app_link_code": "AL1013",
        "mt_id": 13
    },
    "AL1012": {
        "tiny_url": "https://tinyurl.com/yzy9ogjb",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/12",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1012",
        "v1_app_link_code": "AL1012",
        "mt_id": 12
    },
    "AL1011": {
        "tiny_url": "https://tinyurl.com/yjlzj4c5",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/11",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1011",
        "v1_app_link_code": "AL1011",
        "mt_id": 11
    },
    "AL1010": {
        "tiny_url": "https://tinyurl.com/ygs2hu69",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/10",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1010",
        "v1_app_link_code": "AL1010",
        "mt_id": 10
    },
    "AL1009": {
        "tiny_url": "https://tinyurl.com/yk53kggs",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/9",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1009",
        "v1_app_link_code": "AL1009",
        "mt_id": 9
    },
    "AL1008": {
        "tiny_url": "https://tinyurl.com/yz7t4gke",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/8",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1008",
        "v1_app_link_code": "AL1008",
        "mt_id": 8
    },
    "AL1007": {
        "tiny_url": "https://tinyurl.com/ygpj29u7",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/7",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1007",
        "v1_app_link_code": "AL1007",
        "mt_id": 7
    },
    "AL1006": {
        "tiny_url": "https://tinyurl.com/yf3ztfyr",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/6",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1006",
        "v1_app_link_code": "AL1006",
        "mt_id": 6
    },
    "AL1005": {
        "tiny_url": "https://tinyurl.com/yfqgm7qs",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/5",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1005",
        "v1_app_link_code": "AL1005",
        "mt_id": 5
    },
    "AL1004": {
        "tiny_url": "https://tinyurl.com/yeqpkymx",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/4",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1004",
        "v1_app_link_code": "AL1004",
        "mt_id": 4
    },
    "AL1003": {
        "tiny_url": "https://tinyurl.com/yfeglxfr",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/3",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1003",
        "v1_app_link_code": "AL1003",
        "mt_id": 3
    },
    "AL1002": {
        "tiny_url": "https://tinyurl.com/yj5ay26y",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/2",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1002",
        "v1_app_link_code": "AL1002",
        "mt_id": 2
    },
    "AL1001": {
        "tiny_url": "https://tinyurl.com/yentjyg6",
        "mt_url": "https://genesis.trinitypaysol.com/startapp/edit/AL/1",
        "v1_url": "https://trinityapps.web.app/startapp/edit/AL/AL1001",
        "v1_app_link_code": "AL1001",
        "mt_id": 1
    }
}